export default __webpack_public_path__ + "static/0210-1ce2b37ad6f1b5e6c029fbcac28acebf.png";